/**
  * This function handles two aspects:
  * 1. (a) READ VALUE from the textarea, (b) DETECT IF TEXT PER LINE IS TOO LONG  as required by the length restrictions,
     (c) PUSH OVERFLOWING TEXT from a line to the next line and (d) WRITE VALUE back to the textarea.
  * 2. (a) READ THE CURSOR POSITION to store the cursor position, and (b) POSITION THE CURSOR where a user would expect it after WRITE DATA.
  * @param {Object} e - event target
  */

let textOutput="";
let onPaste = false;
let firstInput = 0;

function formatTextAsRequired(e) {
    const $this = $(this);
    firstInput += 1;
    if (this.defaultValue && firstInput === 1) { //update textOutput with predefined value
        textOutput = this.defaultValue;
    }
    const $form = $this.closest("form");
    let { charactersPerLine, maxLines } = e.data;
    let textInput = $this.val();
    let inputAsRows = textInput.split("\n");
    let cursorPositionOnInput = $this.prop("selectionStart");// read cursor position
    let cursorOffsetAfterOutput = 0; // set default value for cursor offset. Cursor offset is needed when re-positioning the cursor after Write Data

    let totalRows = inputAsRows.length;
    let row;

    for (row = 0; row < totalRows; ++row) {
        if (inputAsRows[row].length > charactersPerLine) {// DETECT IF TEXT PER LINE IS TOO LONG
            if (inputAsRows[row+1] === undefined) {
                inputAsRows[row+1] = "";// the row did not exist
                totalRows++;
            }
            //1c PUSH OVERFLOWING TEXT: move text that is too long for this row to the next row:
            inputAsRows[row+1] = inputAsRows[row].substring(charactersPerLine) + inputAsRows[row+1];
            inputAsRows[row] = inputAsRows[row].substring(0, charactersPerLine);
            //determine, if cursor was at the end of the line that got a line-break:
            let newOutput = inputAsRows.join("\n");
            if (newOutput.substr(cursorPositionOnInput-1, 1) === "\n") {
                cursorOffsetAfterOutput = 1;
            }
        }
    }

    const $giftMessage = $form.find(".giftMessage-leftChar-message").add(".personalization-textarea-counter");
    const $giftMessageLeftChars = $form.find(".giftMessage-leftChar");
    const $usedChars = (inputAsRows.length <= 1) ? textInput.length : (totalRows - 1) * charactersPerLine + inputAsRows[totalRows - 1].length;
    if (inputAsRows.length <= maxLines && $usedChars <= (maxLines * charactersPerLine)) { //data is within max number of rows and max total digits
        textOutput = inputAsRows.join("\n");
        $giftMessage.removeClass("invalid-length");
        $giftMessageLeftChars.text(charactersPerLine * maxLines - $usedChars);
        if (onPaste) {
            cursorOffsetAfterOutput = cursorOffsetOnPaste(textInput, cursorPositionOnInput, totalRows);
        }
    } else {
        $giftMessageLeftChars.text(0);
        $giftMessage.addClass("invalid-length");
        cursorOffsetAfterOutput=-1;
    }

    $this.val(textOutput);//1d: WRITE VALUE
    $this.prop("selectionStart", cursorPositionOnInput + cursorOffsetAfterOutput);// POSITION CURSOR
    $this.prop("selectionEnd", cursorPositionOnInput + cursorOffsetAfterOutput);//set a single cursor, not a selection
    onPaste=false;
}

/**
 * count line breaks in textarea
 * @param {String} string - text input in textarea
 * @param {Number} lengthFromStart - textarea message length
 */
function countLineBreaks(string, lengthFromStart) {
    let left = string.substr(0, lengthFromStart);
    return left.split("\n").length;
}

/**
 * initialize paste event
 */
function handlePaste() {
    onPaste = true;
}

/**
 * offset the cursor by 1 for each added line break:
 * @param {String} textInput - text input in textarea field
 * @param {Number} cursorPositionOnInput - cursor position on input
 * @param {Number} totalRows - number of rows in inputfield
 */
function cursorOffsetOnPaste(textInput, cursorPositionOnInput, totalRows) {
    let countOld = countLineBreaks(textInput, cursorPositionOnInput);
    let countNew = countLineBreaks(textOutput, cursorPositionOnInput + totalRows);
    return countNew - countOld;
}

module.exports = {
    formatTextAsRequired,
    handlePaste
};
